"use client";

import { ShieldCheck } from "lucide-react";
import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureYourWorkplaceToday() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="secure-your-workplace-today" className="dark bg-background text-foreground py-24 px-4 relative overflow-hidden flex items-center justify-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-sidebar-accent)_0%,transparent_70%)] opacity-40 pointer-events-none"></div>

      <div ref={ref} className={`container mx-auto max-w-3xl text-center relative z-10 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="inline-flex items-center justify-center p-4 bg-sidebar-accent/50 rounded-full mb-8 border border-border/50">
          <ShieldCheck className="w-10 h-10 text-chart-2" />
        </div>

        <h2 className="text-4xl md:text-[48px] font-extrabold text-foreground mb-6 leading-tight tracking-tight">
          Ready to Prioritize Workplace Safety?
        </h2>

        <p className="text-muted-foreground text-lg md:text-xl mb-10 max-w-2xl mx-auto leading-relaxed">
          Partner with Scott Smith Consulting to build a proactive safety culture, ensure regulatory compliance, and protect your most valuable assets with expert guidance.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-[0_0_20px_var(--color-primary)] hover:shadow-[0_0_30px_var(--color-primary)] transition-all duration-300 text-lg px-10 py-7 h-auto w-full sm:w-auto rounded-md font-bold tracking-wide">
            <Link to="/LetsTalkSafetyPage">
              Book Your Audit
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="text-lg px-10 py-7 h-auto w-full sm:w-auto rounded-md font-semibold border-border hover:bg-sidebar-accent transition-colors duration-300">
            <Link to="/TheExpertPage">
              Meet The Expert
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}